import React, { Fragment, useEffect, useState } from "react";
import { Drawer, Collapse } from "@mui/material";
import { useLocation, Link, useNavigate } from "react-router-dom";
import {
  FaShoppingBag,
  FaMale,
  FaCapsules,
  FaEye,
  FaListAlt,
  FaInfoCircle,
  FaBlog,
  FaEnvelope,
  FaFileAlt,
  FaShieldAlt,
  FaTimesCircle,
  FaUserTie
} from "react-icons/fa";

import { GrCaretNext } from "react-icons/gr";
import LoginIcon from "../../icons/LoginIcon";
import LogoutIcon from "../../icons/LogoutIcon";
import UserIcon from "../../icons/UserIcon";
import { checkLoggedIn } from "../../utils";
import "./style.css";

// Flattened menu structure
const menus = [
  {
    id: 1,
    title: "Shop",
    link: "/shop",
    icon: <FaShoppingBag />,
  },
  {
    id: 2,
    title: "Men's Health",
    link: "/shop?category=Men%27s+Health",
    icon: <FaUserTie />,
    submenu: [
      { 
        id: "mens-3",
        title: "The Blue Pill (Sildenafil)",
        link: "/shop?category=Men's+Health&sub_category=The+Blue+Pill+(Sildenafil)",
        icon: <GrCaretNext />,
      },
      {
        id: "mens-4",
        title: "The WeekEndPill (Tadalafil)",
        link: "/shop?category=Men's+Health&sub_category=The+WeekEndPill+(Tadalafil)",
        icon: <GrCaretNext />,
      },
      {
        id: "mens-5",
        title: "Vardenafil",
        link: "/shop?category=Men's+Health&sub_category=Vardenafil",
        icon: <GrCaretNext />,
      },
    ],
  },
  {
    id: 3,
    title: "Eye Care",
    link: "/shop?category=Eye+Care",
    icon: <FaEye />,
  },
  {
    id: 4,
    title: "Your Orders",
    link: "/your-orders",
    icon: <FaListAlt />,
  },
  {
    id: 5,
    title: "About Us",
    link: "/about",
    icon: <FaInfoCircle />,
  },
  {
    id: 6,
    title: "Blogs",
    link: "/blogs",
    icon: <FaBlog />,
  },
  {
    id: 7,
    title: "Contact Us",
    link: "/contact",
    icon: <FaEnvelope />,
  },
  {
    id: 8,
    title: "Terms & Conditions",
    link: "/terms-and-condition",
    icon: <FaFileAlt />,
  },
  {
    id: 9,
    title: "Drug Policy",
    link: "/drug-policy",
    icon: <FaShieldAlt />,
  },
  {
    id: 10,
    title: "Cancellation Policy",
    link: "/cancellation-refund-policy",
    icon: <FaTimesCircle />,
  },
];

const MobileMenu = ({ isAuth, token, openLogoutModal, configs }) => {
  const navigate = useNavigate();
  const location = useLocation();

  const [menuActive, setMenuState] = useState(false);
  const [openSubId, setOpenSubId] = useState(null);

  const ClickHandler = (path) => {
    navigate(path);
    setMenuState(false);
  };

  useEffect(() => {
    setMenuState(false);
  }, [checkLoggedIn()]);

  return (
    <>
      <div className="showmenu mobail-menu m-10" onClick={() => setMenuState(!menuActive)}>
        <button type="button" className="navbar-toggler open-btn">
          <span className="icon-bar first-angle"></span>
          <span className="icon-bar middle-angle"></span>
          <span className="icon-bar last-angle"></span>
        </button>
      </div>

      <Drawer
        open={menuActive}
        onClose={() => setMenuState(false)}
        sx={{
          "& .MuiDrawer-paper": {
            zIndex: "9999",
            width: "300px",
            background: "#102d62",
          },
        }}
      >
        <div className="menu-close m-10">
          <div className="close" onClick={() => setMenuState(false)}>
            <i className="icon-icon_close"></i>
          </div>
        </div>
        <ul className="responsivemenu p-10">
          {/* First group: Shop, Men's Health, Eye Care */}
          {menus.slice(0, 3).map((item) => (
            <Fragment key={item.id}>
              <button
                onClick={() =>
                  item.submenu ? setOpenSubId(openSubId === item.id ? null : item.id) : ClickHandler(item.link)
                }
                className={`mobile-nav-link-btn ${
                  item.link === location.pathname ? "mobile-nav-link-btn-active" : ""
                }`}
              >
                {item.icon}
                {item.title}
              </button>
              {item.submenu && (
                <Collapse in={openSubId === item.id}>
                  {item.submenu.map((sub) => (
                    <button
                      key={sub.id}
                      onClick={() => ClickHandler(sub.link)}
                      className="mobile-nav-link-btn submenu-btn"
                      style={{ paddingLeft: 32, fontSize: 14 }}
                    >
                      {sub.icon}
                      {sub.title}
                    </button>
                  ))}
                </Collapse>
              )}
            </Fragment>
          ))}
          <hr style={{ margin: "12px 0", borderColor: "#eee" }} />

          {/* Second group: Your Orders, About Us, Blogs */}
          {menus.slice(3, 6).map((item) => (
            <Fragment key={item.id}>
              <button
                onClick={() =>
                  item.submenu ? setOpenSubId(openSubId === item.id ? null : item.id) : ClickHandler(item.link)
                }
                className={`mobile-nav-link-btn ${
                  item.link === location.pathname ? "mobile-nav-link-btn-active" : ""
                }`}
              >
                {item.icon}
                {item.title}
              </button>
              {item.submenu && (
                <Collapse in={openSubId === item.id}>
                  {item.submenu.map((sub) => (
                    <button
                      key={sub.id}
                      onClick={() => ClickHandler(sub.link)}
                      className="mobile-nav-link-btn submenu-btn"
                      style={{ paddingLeft: 32, fontSize: 14 }}
                    >
                      {sub.icon}
                      {sub.title}
                    </button>
                  ))}
                </Collapse>
              )}
            </Fragment>
          ))}
          <hr style={{ margin: "12px 0", borderColor: "#eee" }} />

          {/* Remaining menu items */}
          {menus.slice(6).map((item) => (
            <Fragment key={item.id}>
              <button
                onClick={() =>
                  item.submenu ? setOpenSubId(openSubId === item.id ? null : item.id) : ClickHandler(item.link)
                }
                className={`mobile-nav-link-btn ${
                  item.link === location.pathname ? "mobile-nav-link-btn-active" : ""
                }`}
              >
                {item.icon}
                {item.title}
              </button>
              {item.submenu && (
                <Collapse in={openSubId === item.id}>
                  {item.submenu.map((sub) => (
                    <button
                      key={sub.id}
                      onClick={() => ClickHandler(sub.link)}
                      className="mobile-nav-link-btn submenu-btn"
                      style={{ paddingLeft: 32, fontSize: 14 }}
                    >
                      {sub.icon}
                      {sub.title}
                    </button>
                  ))}
                </Collapse>
              )}
            </Fragment>
          ))}

          {/* Auth Buttons */}
          {isAuth && token ? (
            <div className="flex items-center gap-2 mt-4">
              <button className="logout-button" onClick={openLogoutModal}>
                <LogoutIcon />
                <span className="ml-4 flex flex-col text-black">
                  <small style={{ whiteSpace: "nowrap", width: "100px", overflow: "hidden", textOverflow: "ellipsis" }}>
                    {configs?.fullname}
                  </small>
                  <span>Log Out</span>
                </span>
              </button>
              <Link to="/user-profile">
                <button className="profile-button ml-2">
                  <UserIcon />
                </button>
              </Link>
            </div>
          ) : (
            <button className="logout-button mt-4" onClick={() => ClickHandler("/login")}>
              <LoginIcon />
              <span className="flex flex-col text-black">
                <small style={{ whiteSpace: "nowrap", width: "100px", overflow: "hidden", textOverflow: "ellipsis" }}>
                  My Account
                </small>
                <small>Hello, Sign in</small>
              </span>
            </button>
          )}
        </ul>
      </Drawer>
    </>
  );
};

export default MobileMenu;
